import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { GlobalNotificationService } from '../../core/services/global-notification.service';
import { GlobalNotification } from '@completion/models';

@Component({
  selector: 'app-global-notification-banner',
  templateUrl: './global-notification-banner.component.html',
  styleUrls: ['./global-notification-banner.component.scss'],
  standalone: false,
})
export class GlobalNotificationBannerComponent implements OnInit, OnDestroy {
  notifications: GlobalNotification[] = [];
  private readonly destroy$ = new Subject<void>();

  constructor(private readonly notificationService: GlobalNotificationService) {}

  ngOnInit(): void {
    this.notificationService
      .watchActive()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (notifications) => {
          this.notifications = notifications.filter((notification) => !this.isDismissed(notification.id));
        },
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  dismiss(notification: GlobalNotification): void {
    window.localStorage.setItem(this.storageKey(notification.id), 'true');
    this.notifications = this.notifications.filter((item) => item.id !== notification.id);
  }

  private isDismissed(id: number): boolean {
    return window.localStorage.getItem(this.storageKey(id)) === 'true';
  }

  private storageKey(id: number): string {
    return `completion.global-notification.dismissed.${id}`;
  }
}
